import { any, number } from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import AdditionalFullFilmentOption from '@components/Share/AdditionalFullFilmentOption';
import { getAvailabilityStoresSelector } from '@redux/reducers/bopis/getAvailabilityStores/selector';
import {
  getClientSOCartSelector
} from '@redux/reducers/personalizeOffer/getClientSOCartReducer/getClientSOCartSelector';
import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { DELIVERY_OPTION } from '@utils/constant';

import PickupFromStore from '../../../BuyingOptions/BOShippingInfo/PickupFromStore';
import { useUpdateDeliveryOption } from './hooks';

const RadioOption = ({
  dataSources,
  deliveryItem,
  deliveryIdx
}) => {
  const { data: clientSOCartData } = useSelector(getClientSOCartSelector);
  const { data: bopisAvailabilityStore } = useSelector(getAvailabilityStoresSelector);
  const updateDeliveryOptionService = useUpdateDeliveryOption();

  const isDisabledOption = useMemo(() => {
    let isDisable = !!clientSOCartData?.SOCart || deliveryItem.isDisabled;
    if (deliveryItem?.ShippingOptionType?.Value === DELIVERY_OPTION.PickUpStore && !bopisAvailabilityStore?.length) {
      isDisable = true;
    }

    return isDisable;
  }, [clientSOCartData?.SOCart, deliveryItem, bopisAvailabilityStore]);

  const handleSelectDeliveryOption = useCallback(() => updateDeliveryOptionService(deliveryItem), [deliveryItem]);

  return (
    <li className='cart-fulfilment-option__list-item'>
      <div className={['cart-item-delivery__option__group osim-radio', isDisabledOption ? 'disable' : ''].join(' ')}>
        <input
          type='radio'
          name='fulfilment-option-radio'
          checked={deliveryItem.ExternalId === deliveryItem.DeliveryOptionId}
          id={`${deliveryItem.ExternalCartLineId}-${deliveryIdx}`}
          value={deliveryItem.ExternalId}
          className='osim-radio-input'
          disabled={isDisabledOption}
          onChange={() => handleSelectDeliveryOption((
            deliveryItem
          ))}
        />
        <label htmlFor={`${deliveryItem.ExternalCartLineId}-${deliveryIdx}`} className='osim-radio-label'></label>
        <label
          htmlFor={`${deliveryItem.ExternalCartLineId}-${deliveryIdx}`}
          className='cart-item-delivery__option__text link-text link-text--gray-darker'
        >
          {deliveryItem.Name}
        </label>
      </div>
      {deliveryItem.ShippingOptionType.Value === DELIVERY_OPTION.ShipItem ? <>
        {deliveryItem.IsInStockProduct ? (
          <small
            className='smaller-text option-description'
          >{deliveryItem['InStockDeliveryLabel']}</small>
        ) : deliveryItem.IsOutStockProduct ?
          (
            <small
              className='smaller-text option-description'
            >{deliveryItem['OutStockDeliveryLabel']}</small>
          ) : deliveryItem.IsPreOrderProduct
            ? (
              <small
                className='smaller-text option-description'
              >{deliveryItem['PreOrderDeliveryLabel']}</small>
            )
            : deliveryItem.IsBackOrderProduct ? (
              <small
                className='smaller-text option-description'
              >{deliveryItem['BackOrderDeliveryLabel']}</small>
            ) : (
              <></>
            )}
        {!deliveryItem.IsOutStockProduct ? (
          <AdditionalFullFilmentOption
            cssCustom='option-description'
            inputData={SitecoreContextFactoryService.getValueContextRouteItem('fields')}
          />
        ) : (
          <></>
        )}
      </> : (
        <></>
      )}
      {deliveryItem.ShippingOptionType.Value === DELIVERY_OPTION.SFExpress ? <>
        <Text className='smaller-text smaller-text--sf-express' field={dataSources['Available Label']} tag='small' />
        <RichText
          className='smaller-text smaller-text--inline'
          tag='small'
          field={dataSources['SF Express Station Label']}
        />
      </> : (
        <></>
      )}
      {deliveryItem.ShippingOptionType.Value === DELIVERY_OPTION.PickUpStore
        ? (
          <PickupFromStore
            textClassName='small-text option-description'
            isShowIcon={false}
            addressSetting={dataSources?.['Address Settings']}
          />
        )
        : (
          <></>
        )}
      {deliveryItem.ShippingOptionType.Value === DELIVERY_OPTION.DeliveryBySFExpress
        ? <small className='smaller-text' dangerouslySetInnerHTML={{ __html: deliveryItem.Description }}></small>
        : (
          <></>
        )}
    </li>
  );
};

RadioOption.propTypes = {
  dataSources: any,
  deliveryItem: any,
  deliveryIdx: number
};

export default RadioOption;